import { render, staticRenderFns } from "./InstancesCard.vue?vue&type=template&id=98c03984"
import script from "./InstancesCard.vue?vue&type=script&lang=js"
export * from "./InstancesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports